import { apiGet, apiPost } from "./api";

/** Crear Orden de Cobro de Remitos */
export function postOrdenCobroRemito(payload) {
  return apiPost(`/ordencobroremitos`, payload);
}

/** Editar Orden de Cobro de Remitos */
export function editarOrdenCobroRemito(id, payload) {
  return apiPost(`/ordencobroremitos/${id}/editar`, payload);
}

/** Listar OCR con filtros */
export function getOrdenesCobroRemitos({ cliente, proveedor, desde, hasta } = {}) {
  const q = new URLSearchParams();
  if (cliente) q.set("cliente", cliente);
  if (proveedor) q.set("proveedor", proveedor); // lo dejamos por simetría con back
  if (desde) q.set("desde", desde);
  if (hasta) q.set("hasta", hasta);
  return apiGet(`/ordencobroremitos${q.toString() ? "?" + q.toString() : ""}`);
}

/** Get por id */
export function getOrdenCobroRemitoById(id) {
  return apiGet(`/ordencobroremitos/${id}`);
}

/** Anular */
export function anularOrdenCobroRemito(id) {
  return apiPost(`/ordencobroremitos/${id}/anular`, {});
}
